export default "__VITE_ASSET__Ci5j1T_1__"